export default __webpack_public_path__ + "static/media/lista-boletos-example.4cd73d6d.png";